import * as types from 'actions/actionTypes';
import initialState from './initialState';

/**
 * gestisce la selected rowindex
 * @param {*} state
 * @param {*} action
 */
export default function gridReducer(state = initialState.grid, action){

    switch(action.type)
    {
        case types.GRID_SAVEROWINDEX:
        console.info("GRID_SAVEROWINDEX");
            return {...state,
                rowIndex: action.data
            }

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/gridReducer.js